import React, { useState } from 'react'
import MainContext from './MainContext';
import { signup, login, getAllOwners, googleLogin } from './contextPages/AuthContexts';
import { fetchAllClients, createClient, deleteClient } from './contextPages/ClientContexts';
import { fetchAllAppointments,fetchStaffAppointmentsDateWise, createAppointment, deleteAppointment, fetchAppointmentsByStaff } from './contextPages/AppointmentContexts';
import { fetchAllStaffs, createStaff,createAttandence, deleteStaff, getStaffById,forgotpassowrd ,fetchAttendanceByStaffId,fetchOverview} from './contextPages/StaffContexts';
import { fetchAllBranch, createBranch, deleteBranch } from './contextPages/BranchContexts';
import { getAllRequests, updateRequest } from './contextPages/SubscriptionsContexts';

import {
    salarySlip,
    applyStaffLeave,
    fetchStaffLeaves,
  } from './contextPages/StaffContexts';


const MainState = (props) => {
    const [activeStaffData,setActiveStaffData]=useState({})
    const [activeStaffId,setActiveStaffId]=useState(null)
    const [branchId,setBranchId]=useState(null)
    const [showMessage,setShowMessage]= useState({})
    return (
        <>
            <MainContext.Provider value={{
                showMessage,
                setShowMessage,

                
                activeStaffData,
                setActiveStaffData,
                activeStaffId,
                setActiveStaffId,
                branchId,
                setBranchId,

                fetchAllBranch,
                createBranch,
                deleteBranch,

                fetchAllStaffs,
                fetchAttendanceByStaffId,
                createStaff,
                deleteStaff,
                getStaffById,
                fetchOverview,

                fetchStaffAppointmentsDateWise,
                fetchAllAppointments,
                createAppointment,
                deleteAppointment,
                fetchAppointmentsByStaff,
                forgotpassowrd,

                fetchAllClients,
                createClient,
                deleteClient,

                signup,
                login,
                
                getAllOwners,
                googleLogin,

                getAllRequests,
                updateRequest,
                createAttandence,
                salarySlip,
                fetchStaffLeaves,
                applyStaffLeave,
            }}>
                {props.children}
            </MainContext.Provider>
        </>
    );
};

export default MainState;
